import { cacheDom } from '../utils/QuerySelectors.js'
import { addLineItems } from '../utils/Cart.js'
import { toggleModal } from '../components/Popup.js'
import { getStoreQuery, formatStoreData } from '../utils/Store.js'
import { makeRequest } from '../utils/Storefront.js'
import { validateEmail, privatePrices, onlyUnique } from '../utils/helpers.js'

const dom = {}
const qs = {
  section: 'data-section-type="main-product"',
  selectedVariant: 'data-selected-variant',
  swiper: 'data-images',
  countrySelector: 'data-size-country-selector',
  popup: 'data-popup',
  popupContent: 'data-popup-content',
  embossingCheck: 'data-embossing-check',
  productJson: 'data-main-product-json',
  bisEmail: 'data-bis-email',
  bisSubmit: 'data-bis-submit',
  bisErrorMsg: 'data-bis-error-msg',
  newsletterSubscribe: 'data-bis-signup',
  // scrollIndicator: 'data-scroll-indicator',
  stylesBtn: 'data-styles-popup-btn',
  expressPaymentTrigger: 'data-express-payment-trigger',
  expressPaymentDetails: 'data-express-payment-details',
  expressPaymentClose: 'data-express-payment-close',
  regularPrice: 'data-pdp-regular-price',
  privatePrice: 'data-pdp-private-price',
  findInStore: 'data-find-in-store',
  fisResults: 'data-fis-results',
  jpForm: 'data-jp-form',
}
const qsAll = {
  accordions: 'data-product-accordion',
  content: 'data-product-accordion-content',
  images: 'data-product-img',
  addToCartBtns: 'data-atc',
  sizeSwatches: 'data-size-swatch',
  guideBtns: 'data-sizeguide',
  sizePanels: 'data-size-panel',
  sizeTabBtns: 'data-table-id',
  sizeTables: 'data-size-table',
  oldSizeTabBtns: 'data-old-guide-btn',
  oldGuidePanels: 'data-old-guide-panel',
  styleUrls: 'data-style-product',
  fisSwatches: 'data-fis-size-swatch',
  switchColor: 'data-gtm-switch-color',
}
const state = {
  json: null,
}

const manageZoom = (image, e) => {
  if (image.classList.contains('main-product--img__zoom')) {
    image.style.transform = 'scale(3)'
    image.style.transformOrigin = `${(e.offsetX / image.offsetWidth) * 100.0}% ${(e.offsetY / image.offsetHeight) * 100.0}%`
  } else {
    image.style = ''
  }
}

const initSwiper = () => {
  if (window.innerWidth >= 1024) {
    if (dom.swiper.swiper) dom.swiper.swiper.destroy(true, true)
  } else {
    if (!dom.swiper.swiper) {
      new Swiper(dom.swiper, {
        speed: 400,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      })
    }
  }
}

const initSizeGuide = () => {
  const countrySelector = dom.popup.querySelector(`[${qs.countrySelector}]`)
  const panels = dom.popup.querySelectorAll(`[${qsAll.sizePanels}]`)
  countrySelector.addEventListener('input', () => {
    panels.forEach((sizePanel) => sizePanel.classList.toggle('hidden', sizePanel.id != countrySelector.value))
  })
  panels.forEach((panel) => {
    const sizeTabBtns = panel.querySelectorAll(`[${qsAll.sizeTabBtns}]`)
    const sizeTables = panel.querySelectorAll(`[${qsAll.sizeTables}]`)
    sizeTabBtns.forEach((sizeTabBtn) => {
      sizeTabBtn.addEventListener('click', () => {
        sizeTabBtns.forEach((btn) => btn.classList.toggle('button--primary', btn == sizeTabBtn))
        sizeTables.forEach((table) =>
          table.classList.toggle('hidden', table.id != sizeTabBtn.getAttribute('data-table-id')),
        )
      })
    })
  })
}

const initOldSizeGuide = () => {
  const oldSizeTabBtns = dom.popup.querySelectorAll(`[${qsAll.oldSizeTabBtns}]`)
  const oldGuidePanels = dom.popup.querySelectorAll(`[${qsAll.oldGuidePanels}]`)
  oldSizeTabBtns.forEach((oldSizeTabBtn) => {
    oldSizeTabBtn.addEventListener('click', () => {
      oldSizeTabBtns.forEach((btn) => {
        btn.classList.add('button--primary')
        btn.classList.remove('button--secondary')
      })
      oldSizeTabBtn.classList.remove('button--primary')
      oldSizeTabBtn.classList.add('button--secondary')

      oldGuidePanels.forEach((panel) => {
        panel.style.display =
          panel.getAttribute(`${qsAll.oldGuidePanels}`) == oldSizeTabBtn.getAttribute(`${qsAll.oldSizeTabBtns}`)
            ? ''
            : 'none'
      })
    })
  })
}

const initBIS = () => {
  // Klaviyo Back In Stock
  const bisSubmit = document.querySelector(`[${qs.popup}] [${qs.bisSubmit}]`)
  const bisEmail = document.querySelector(`[${qs.popup}] [${qs.bisEmail}]`)
  const bisErrorMsg = document.querySelector(`[${qs.popup}] [${qs.bisErrorMsg}]`)
  const newsletterSubscribe = dom.popup.querySelector(`[${qs.newsletterSubscribe}]`)

  bisEmail.addEventListener('input', () => {
    bisErrorMsg.classList.add('hidden')
    bisSubmit.classList.toggle('button--secondary', !validateEmail(bisEmail.value.trim()))
    bisSubmit.classList.toggle('button--primary', validateEmail(bisEmail.value.trim()))
    bisEmail.classList.toggle('klaviyo-bis-input--filled', bisEmail.value.trim() != '')
  })
  bisSubmit.addEventListener('click', () => {
    if (validateEmail(bisEmail.value.trim())) {
      let mediumValue = bisEmail.value.trim() // Email Address to subscribe
      let medium = "email" // 'email' or 'sms'
      let topic = "backinstock" // the topic of "backinstock" configured at our backend.
      // Product data of the product
      let product = {
        epi: parseInt(dom.selectedVariant.value), // unique variant ID of the product.
        empi: state.json.id, // Product ID or master product ID
        du: location.href, // canonical product url.
        iu: state.json.featured_image, // image url for email
        pr: state.json.price / 100.0, // price
      }

      if(Shopify.theme.role == 'main') {
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: bisEmail.value,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${dom.selectedVariant.value}`,
                },
              },
            },
          },
        }
        const requestOptions = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            revision: '2024-05-15',
          },
          body: JSON.stringify(payload),
        }

        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoApiKey}`,
          requestOptions,
        )
          .then((result) => {
            console.log(result)
            toggleModal(true, document.querySelector('#klaviyoBisSuccess').innerHTML, null)
          })
          .catch((error) => {
            console.log('errorr', error)
            bisErrorMsg.classList.remove('hidden')
            bisErrorMsg.innerHTML = window.bisStrings.error
          })
      } else {
        // Success Callback
        let onSuccess = function(response) {
          console.log("Successfully Subscribed the email for the alert.", response)
          toggleModal(true, document.querySelector('#klaviyoBisSuccess').innerHTML, null)
        }

        // Error Callback
        let onError = function(error) {
          console.log("Error While subscribing the email for the alert.", error)
          bisErrorMsg.classList.remove('hidden')
          bisErrorMsg.innerHTML = window.bisStrings.error
        }
        // Sample call..
        if(typeof _swat !== 'undefined') {
          _swat.subscribeForProductAlert(mediumValue, medium, product, onSuccess,onError,0 ,topic)
        }
      }

      if (newsletterSubscribe.checked) {
        if(Shopify.theme.role == 'main') {
          const options = {
            method: 'POST',
            headers: { revision: '2024-07-15', 'content-type': 'application/json' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        properties: { SubscribeSource: 'Back In Stock Popup' },
                        email: bisEmail.value,
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: 'W6335U' } } },
              },
            }),
          }
          fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoApiKey}`, options)
            .then((response) => response.json())
            .then((response) => console.log(response))
            .catch((err) => console.error(err))
        } else {
          fetch(`https://${window.tbApiDomain}/upsert_lead`, {
            method: 'POST',
            headers: new Headers({
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }),
            body: JSON.stringify(
              {
                "lead": {
                  "salutation": "",
                  "first_name": "",
                  "last_name": "",
                  "interests": "",
                  "email": mediumValue,
                  "country": Shopify.country,
                  "language": Shopify.locale,
                  "marketing_consent_flag": true,
                  "privacy_consent_flag": true
                }
              }
            ),
          })
        }
      }
    } else {
      bisErrorMsg.classList.remove('hidden')
      bisErrorMsg.innerHTML = window.bisStrings.emailError
    }
  })
}

const initFindInStore = () => {
  const fisResults = dom.popup.querySelector(`[${qs.fisResults}]`)
  const fisSwatches = dom.popup.querySelectorAll(`[${qsAll.fisSwatches}]`)
  const activeSwatch = document.querySelector(`.swatch--active[${qsAll.sizeSwatches}]`)
  let activeFisSwatch = activeSwatch
    ? Array.from(fisSwatches).filter(
        (fis) => fis.getAttribute('data-fis-size-variant') == activeSwatch.getAttribute(qsAll.sizeSwatches),
      )[0]
    : null

  Shopify.analytics.publish('gtm_find_in_store');

  fisSwatches.forEach((fisSwatch) => {
    fisSwatch.addEventListener('click', () => {
      fisResults.classList.add('is-loading')
      fisResults.innerHTML = ''
      fisSwatches.forEach((swatch) => swatch.classList.toggle('swatch--active', swatch == fisSwatch))
      fetch(`https://${window.tbApiDomain}/find_in_store?barcode=${fisSwatch.getAttribute(qsAll.fisSwatches)}`)
        .then((res) => res.text())
        .then((html) => {
          if(html.includes('barcode not found')) {
            fisResults.innerHTML = window.productStrings.findInStore.productNotAvailable
          } else {
            fisResults.innerHTML = html
          }
          const rows = Array.from(fisResults.querySelectorAll('.find-store-result-row'))
          let hiddenCount = 0
          rows.forEach(row => {
            const code = row.getAttribute('store')
            const storeData = window.storesList.filter(store => code && store.code == code)[0]
            let order = 0
            if(storeData) {
              if(Shopify.country == 'US' && storeData.country == 'united states') order = -1
              if(Shopify.country == 'UK' && storeData.country == 'united kingdom') order = -1
              if(Shopify.country == 'IT' && storeData.country == 'italy') order = -1
              if(Shopify.country == 'JP' && storeData.country == '日本') order = -1
              row.style.order = order
              row.innerHTML += `
                <div class="find-store-row-store-address">
                  ${storeData.addressFull}
                  <br>
                  <a href="${storeData.url}" class="underline" target="_blank" title="opens the store info in a new window">
                    ${window.productStrings.findInStore.storeInfo}
                  </a>
                </div>
              `
            } else {
              row.classList.add('!hidden')
              hiddenCount += 1
            }
          })
          if(hiddenCount == rows.length) fisResults.innerHTML = window.productStrings.findInStore.productNotAvailable
          fisResults.classList.remove('is-loading')
        })
        .catch((e) => {
          console.error(e)
        })
    })
  })
  if (activeFisSwatch) activeFisSwatch.dispatchEvent(new Event('click'))
}

export const setupMainProduct = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    privatePrices()
    state.json = JSON.parse(dom.productJson.innerHTML)

    // Push the product id into Recently viewed products list
    let recentIds = Cookies.get('recently_viewed_ids')?.split(',') || []
    recentIds.push(`${state.json.id}`)
    Cookies.set(
      'recently_viewed_ids',
      recentIds
        .filter(onlyUnique)
        .slice(Math.max(0, recentIds.length - 20))
        .join(','),
    )

    dom.accordions.forEach((accordion) => {
      accordion.addEventListener('click', () => {
        accordion.closest('.main-product--accordion').classList.toggle('main-product--accordion__open')
        dom.accordions.forEach((acc) => {
          if (acc != accordion)
            acc.closest('.main-product--accordion').classList.remove('main-product--accordion__open')
        })
      })
      accordion.addEventListener('focus', () => {
        accordion.closest('.main-product--accordion').classList.add('main-product--accordion__open')
        dom.accordions.forEach((acc) => {
          if (acc != accordion)
            acc.closest('.main-product--accordion').classList.remove('main-product--accordion__open')
        })
      })
    })
    dom.images.forEach((image) => {
      image.addEventListener('click', (e) => {
        image.classList.toggle('main-product--img__zoom')
        const imageUrl = image.dataset.productImg
        if (image.classList.contains('main-product--img__zoom')) {
          image.querySelector('img').src = imageUrl
          Array.from(image.querySelectorAll('source')).forEach((source) => (source.srcset = imageUrl))
        } else {
          image.querySelector('img').src = imageUrl.replace('width=1920', 'width=500')
          Array.from(image.querySelectorAll('source')).forEach((source) => (source.srcset = source.dataset.src))
        }
        manageZoom(image, e)
      })
      image.addEventListener('mousemove', (e) => {
        manageZoom(image, e)
      })
    })
    dom.addToCartBtns.forEach((addToCartBtn) => {
      addToCartBtn.addEventListener('click', (e) => {
        e.stopPropagation()
        e.preventDefault()
        if (dom.selectedVariant.value) {
          const variant = state.json.variants.filter((v) => v.id == parseInt(dom.selectedVariant.value))[0]
          if (variant.available) {
            e.target.setAttribute('disabled', '')
            const properties = typeof window.privateSale != 'undefined' && window.privateSale && window.showForLoggedInUsers && dom.privatePrice ? { '_discount reason': window.privateSaleReason } : {}
            if (window.isFragrance) properties['_fragrance'] = 'true'
            addLineItems(
              (cart) => {
                initMiniCart(cart)
                window.openCart()
                if (typeof window.activeStyleProduct != 'undefined' && window.activeStyleProduct) {
                  if(typeof gtag != 'undefined') {
                    gtag('event', 'switch_style_and_add_to_bag', {
                      send_to: 'G-83WB7SRKM3/453323169',
                      style: window.activeStyleProduct.style,
                      product: window.activeStyleProduct.product,
                    })
                  }
                }
              },
              [
                {
                  id: dom.selectedVariant.value,
                  quantity: 1,
                  properties,
                },
              ],
              e.target,
            )
          } else {
            toggleModal(true, document.querySelector('#klaviyoBIS').innerHTML, null)
            initBIS()
          }
        }
      })
    })
    dom.selectedVariant.value = dom.sizeSwatches.filter(sizeSwatch => sizeSwatch.classList.contains('swatch--active'))[0]?.getAttribute('data-size-swatch')

    dom.sizeSwatches.forEach((sizeSwatch) => {
      sizeSwatch.addEventListener('click', () => {
        dom.sizeSwatches.forEach((s) => s.classList.toggle('swatch--active', s == sizeSwatch))
        dom.selectedVariant.value = sizeSwatch.getAttribute('data-size-swatch')
        history.pushState({}, '', `${location.origin}${location.pathname}?variant=${dom.selectedVariant.value}`)

        Shopify.analytics.publish('gtm_select_size', {
          product_id: sizeSwatch.dataset.productId,
          variant_id: sizeSwatch.dataset.sizeSwatch,
          item_name: sizeSwatch.dataset.productName,
          size: sizeSwatch.getAttribute('title')
        });

        dom.addToCartBtns.forEach(
          (addToCartBtn) =>
            (addToCartBtn.innerHTML =
              sizeSwatch.getAttribute('data-available') == 'true' ? window.productStrings.addToBag : window.productStrings.notifyMe),
        )

        dom?.expressPaymentDetails.classList?.toggle('express-payment--details__diabled', sizeSwatch.classList.contains('main-product--sizeswatch__oos'))
      })
    })
    initSwiper()
    window.addEventListener('resize', () => {
      initSwiper()
    })

    dom.guideBtns.forEach((guideBtn) => {
      guideBtn.addEventListener('click', () => {

        Shopify.analytics.publish('gtm_size_guide');

        // // New size guide
        // toggleModal(true, document.querySelector('#sizeGuide').innerHTML, null, true, 'bottom', true)
        // initSizeGuide()

        // Old size guide
        toggleModal(true, document.querySelector('#oldSizeGuide').innerHTML, null, true)
        initOldSizeGuide()
      })
    })
    if (dom.embossingCheck) {
      dom.embossingCheck.addEventListener('input', () => {
        if (dom.embossingCheck.checked) toggleModal(true, document.querySelector('#embossingPop').innerHTML, null, true)
      })
    }
    // if (typeof Cookies.get('scrollIndicator') == 'undefined' || !Cookies.get('scrollIndicator')) {
    //   dom.scrollIndicator.style.display = ''
    //   Cookies.set('scrollIndicator', true, { expires: 7 })
    // }
    if (dom.stylesBtn) {
      dom.stylesBtn.addEventListener('click', () => {
        toggleModal(true, document.querySelector('#stylesPopup').innerHTML, null, true, 'bottom', true)

        Shopify.analytics.publish('shop_style');

        const styleUrls = dom.popup.querySelectorAll(`[${qsAll.styleUrls}]`)
        styleUrls.forEach((styleUrl) => {
          styleUrl.addEventListener('click', (e) => {
            e.preventDefault()
            if(typeof gtag != 'undefined') {
              gtag('event', 'style_switcher_click', {
                send_to: 'G-83WB7SRKM3/453323169',
                style: styleUrl.getAttribute(qsAll.styleUrls),
                product: JSON.parse(styleUrl.querySelector('[type="application/json"]').innerHTML),
              })
            }

            setTimeout(() => {
              location.href = styleUrl.href
            }, 100)
          })
        })
      })
    }
    if (location.search && location.search == '?switch_style=true') {
      history.pushState({}, '', location.href.replace(location.search, ''))
      const activeStyle = document.querySelector(`.border.border-black.style-product`)
      if (activeStyle) {
        const styleData = activeStyle.querySelector('[type="application/json"]')
        window.activeStyleProduct = {
          product: JSON.parse(styleData.innerHTML),
          style: styleData.getAttribute('data-style'),
        }
        setTimeout(() => {
          if(typeof gtag != 'undefined') {
            gtag('event', 'switch_style', {
              send_to: 'G-83WB7SRKM3/453323169',
              style: window.activeStyleProduct.style,
              product: window.activeStyleProduct.product,
            })
          }
        }, 500)
      }
    }

    if(dom.expressPaymentTrigger){
      dom.expressPaymentTrigger.addEventListener('click', () => {
        Shopify.analytics.publish('gtm_express_payment');
        dom.expressPaymentDetails.classList.remove('!hidden')
        dom.expressPaymentTrigger.classList.add('!hidden')
      })
    }
    if(dom.expressPaymentClose){
      dom.expressPaymentClose.addEventListener('click', () => {
        dom.expressPaymentDetails.classList.add('!hidden')
        dom.expressPaymentTrigger.classList.remove('!hidden')
      })
    }
    if (typeof window.privateSale != 'undefined' && window.privateSale && window.showForLoggedInUsers && dom.privatePrice) {
      dom.regularPrice.classList.add('!hidden')
      dom.privatePrice.classList.remove('!hidden')
    }
    if (dom.findInStore) {
      dom.findInStore.addEventListener('click', () => {
        toggleModal(true, document.querySelector('#findInStorePopup').innerHTML, null)
        initFindInStore()
      })
    }

    const query = getStoreQuery('store', 250)
    makeRequest((results) => {
      window.storesList = results.data?.metaobjects?.edges
        ?.map((edge) => formatStoreData('store', edge))
        .sort((a, b) => a.order - b.order)
    }, query)
  }

  dom.switchColor.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if(e.currentTarget.tagName == 'A'){
        e.preventDefault();
        const el = e.currentTarget
        Shopify.analytics.publish('gtm_select_color', {
          product_id: el.dataset.productId,
          variant_id: el.dataset.variantId,
          item_name: el.dataset.productName,
          color: el.dataset.color
        });
        window.location = e.currentTarget.href;
      }
    });
  });
}
